import { ModelInfo } from './model-info'

/**
 * Home Content Service
 * @class Home Content
 * @property {string} id 신청 ID
 * @property {string} title 교육명
 * @property {string} startAt 시작일
 * @property {string} finishAt 종료일
 * @property {string} method 교육방식
 * @property {string} level 교육단계
 */
class HomeInfoContent {
  constructor(props) {
    this.id = props.id
    this.title = props.title
    this.startAt = props.startAt
    this.finishAt = props.finishAt
    this.method = props.method
    this.level = props.level
    this.state = props.state
    this.target = props.target
  }
}

/**
 * HomeInfo Service
 * @class HomeInfo
 * @augments ModelInfo
 * @property {array} content 각각의 교육 정보
 */
export class HomeInfo extends ModelInfo {
  constructor(props) {
    super(props)
    this.content = props.content.map((obj) => new HomeInfoContent(obj))
  }
}
